import { Redirect } from "react-router-dom";
import { useRoles } from "../PermissionGate";

const CanCan = ({
  permissionName,
  children,
  showPermissionDeniedPage = false,
}) => {
  const { roles } = useRoles();
  return (
    <>
      {roles?.some((item) => item === permissionName) ? (
        children
      ) : showPermissionDeniedPage ? (
        <Redirect to={{ pathname: "/permissionDenied" }} />
      ) : (
        <></>
      )}
    </>
  );
};

export default CanCan;
